// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import styled from 'styled-components';

import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

const Container = styled(FlexBoxColumn)`
  background-color: ${(props) => props.theme.color.background.basic};
  align-items: flex-start;
  padding: 14px;
  width: 100%;
  //height: 220px;
  border-radius: ${(props) => props.theme.component.mobile.footer.contactInfo.borderRadius};
`;

const InfoTextBox = styled(TextBox)`
  font-size: ${({ size }) => size || moTheme.font.size.$12};
  line-height: ${moTheme.font.lineHeight.demiLight};
  font-weight: ${({ weight }) => weight || moTheme.font.weight.demiLight};
  border-bottom: ${({ isEmphasize, theme }) => (isEmphasize ? `1px solid ${theme.color.line.selected}` : '')};
`;

const TextBold = styled.span`
  font-weight: 500;
  padding-right: 8px;
`;

const KoreanAirSavingsFooterSubNoticeContainer = styled(FlexBoxColumn)`
  align-items: flex-start;
  // height: 126px;
`;

export { Container, InfoTextBox, TextBold, KoreanAirSavingsFooterSubNoticeContainer };
